import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from "rxjs";
import { TermsGiverechargeComponent } from './components/terms-giverecharge/terms-giverecharge.component';
import { AlertasComponent } from '../alertas/alertas.component';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-giverecharge',
  templateUrl: './giverecharge.component.html',
  styleUrls: ['./giverecharge.component.sass']
})
export class GiverechargeComponent implements OnInit {
  //variables Iniciales
  public tabActive = 'Compras';
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public token;
  loadObserver: Subscription;
  //variables locales
  public acceptTerms = false;
  public valueRecharge = "";
  public check1;
  public check2;
  public check3;
  public check4;
  public status;
  public subscriberRecieverName = "";
  public banRecieve = "";
  public amount = 0.00;
  public showErrorCelNum = false;
  public showErrorCelNumInvalido = false;
  public paymentId = "";
  public subscriberReciever = "";
  public fullName;
  public subsriberSend;
  public giftSendMessage;
  public transactionId;
  public paymentType;
  public userName;
  //pay
  public paymentData;
  public paymentscreen = 0;
  public index = 0;
  giftReceived: Subscription;
  constructor(public AngularFireAnalytics: AngularFireAnalytics, private router: Router, public appComponent: AppComponent, private loadingScreenService: LoadingScreenService, private services: Service, public global: GlobalService, public dialog: MatDialog) {
    this.AngularFireAnalytics.setCurrentScreen("Regala una Recarga Prepago");
    this.AngularFireAnalytics.logEvent("Regala una Recarga Prepago-Screenview");
  }

  ngOnInit() {
    if (this.global.sessionReview() == true) {
      this.token = sessionStorage.getItem("token");
      this.userName = atob(sessionStorage.getItem("userName2"));
      this.fullName = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.firstNameField + ' ' + JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.lastNameField;
      this.subsriberSend = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].subscriberNumberField;
      this.loadingScreenService.stopLoading();
      this.giftReceived = this.global.paymentReceived.subscribe((value: boolean) => {
        if (value == true && this.index == 0) {
          const dialogConfig2 = new MatDialogConfig();
          dialogConfig2.disableClose = true;
          dialogConfig2.autoFocus = true;
          dialogConfig2.data = { message: "Gracias: La recarga se ha enviado con exito." };
          const dialogRef2 = this.dialog.open(AlertasComponent, dialogConfig2);
          dialogRef2.afterClosed().subscribe(value2 => {
            if (value2 == "continue") {
              this.initializeData();
            }
          });
        }
      });
    }
  }
  ngAfterViewInit() {
    this.check1 = document.getElementById("check_1") as HTMLInputElement;
    this.check2 = document.getElementById("check_2") as HTMLInputElement;
    this.check3 = document.getElementById("check_3") as HTMLInputElement;
    this.check4 = document.getElementById("check_4") as HTMLInputElement;
  }
  refreshDataTo() {
    let index = parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan", btoa(ban));
    this.initializeData();
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw) {
  }
  showterms() {
    if (sessionStorage.getItem("session") != null) {
      this.global.validateSession();
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    this.dialog.open(TermsGiverechargeComponent, dialogConfig);
  }
  activateTerms() {
    if (this.global.validateSession() === true) {
      this.global.validateSession();
      if (this.acceptTerms) {
        this.acceptTerms = false;
      }
      else {
        this.acceptTerms = true;
      }
    }
  }
  notifpaymentgiverecharge() {
    let typeMessage = 'dataPackage';
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { message: "Estimado cliente este cargo que desea realizar no califica para cargo en factura, por favor continúe su compra efectuando el pago inmediato usando su tarjeta de crédito.", btmConfirm: true, labelSi: 'Pagar', labelNo: 'Cancelar' };
    const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value == 'continue') {
        this.global.newPaymentNoLimit(1, typeMessage, this.selectBan, this.subscriberReciever, this.valueRecharge, atob(sessionStorage.getItem("email")), sessionStorage.getItem("name"), "", this.token);
        let datasend = '{"data":{"module":"giverecharge","params":{"fullNamePay":"' + this.fullName + '","banSendPay":"' + this.selectBan + '","banRecievePay":"' + this.banRecieve + '","subsriberSendPay":"' + JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].subscriberNumberField + '","subsriberRecieverPay":"' + this.subscriberReciever + '","giftSendMessagePay":"' + this.giftSendMessage + '"},"labels":[{"label":"producto","text":"Regala una Recarga de $' + this.valueRecharge + '"},{"label":"monto","text":"$' + this.valueRecharge + '"}],"confirmText":"se ha realizado el pago exitosamente y se ha enviado la recarga","mount":"' + this.valueRecharge + '","product":"Regala una Recarga de $' + this.valueRecharge + '"}}'
        this.paymentData = JSON.parse(datasend);
        //this.paymentscreen=1;
      }
    });
  }
  validateCreditLimit(banRecieve, balanceAccount, amount) {
    this.loadingScreenService.startLoading();
    this.services.validateCreditLimit(this.selectBan, balanceAccount, this.amount).subscribe(data => {
      if (data.HasError == false) {
        var availableCredit = String(data.AvailableCredit);

        this.paymentId = data.paymentid;
        var remaining = parseFloat(availableCredit) - parseFloat(this.amount.toString());
        if (remaining > 0) {
          this.giftRecharge();
        }
        else {
          this.loadingScreenService.stopLoading();
          //this.notifpaymentgiverecharge();
          this.global.notif("Estimado cliente este cargo que desea realizar no califica para cargo en factura.");

          //llamar funcion que construya el json

        }

      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  giftRecharge() {
    this.loadingScreenService.startLoading();
    this.services.giftRecharge(this.token, this.selectBan, this.fullName, this.banRecieve, this.subsriberSend, this.subscriberReciever, this.giftSendMessage, "", this.paymentType, this.valueRecharge, this.userName).subscribe(data => {
      if (data.HasError == false) {
        this.loadingScreenService.stopLoading();
        this.global.notif('Gracias: La recarga se ha enviado con Exito.');

        this.transactionId = data.Gift1GBIDTransact;
        this.subscriberReciever = "";
        this.giftSendMessage = "";
        this.refreshDataTo();
        this.router.navigate(['home']);
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
      }
    });
  }
  option(sw) {
    if (this.global.validateSession() === true) {

      if (sw == 1) {
        document.getElementById("option_1").className = "recarga-opts on";
        document.getElementById("option_2").className = "recarga-opts";
        document.getElementById("option_3").className = "recarga-opts";
        document.getElementById("option_4").className = "recarga-opts";
        this.check1 = document.getElementById("check_1") as HTMLInputElement;
        this.check1.checked = true;
        this.valueRecharge = "10.00";
      }
      else if (sw == 2) {
        document.getElementById("option_2").className = "recarga-opts on";
        document.getElementById("option_1").className = "recarga-opts";
        document.getElementById("option_3").className = "recarga-opts";
        document.getElementById("option_4").className = "recarga-opts";
        this.check2 = document.getElementById("check_2") as HTMLInputElement;
        this.check2.checked = true;
        this.valueRecharge = "12.00";
      }
      else if (sw == 3) {
        document.getElementById("option_3").className = "recarga-opts on";
        document.getElementById("option_2").className = "recarga-opts";
        document.getElementById("option_1").className = "recarga-opts";
        document.getElementById("option_4").className = "recarga-opts";
        this.check3 = document.getElementById("check_3") as HTMLInputElement;
        this.check3.checked = true;
        this.valueRecharge = "20.00";
      }
      else if (sw == 4) {
        document.getElementById("option_4").className = "recarga-opts on";
        document.getElementById("option_2").className = "recarga-opts";
        document.getElementById("option_1").className = "recarga-opts";
        document.getElementById("option_3").className = "recarga-opts";
        this.check4 = document.getElementById("check_4") as HTMLInputElement;
        this.check4.checked = true;
        this.valueRecharge = "30.00";
      }
    }
  }
  notif2() {
    let getAccount = JSON.parse(atob(sessionStorage.getItem("getAccountDetails")));
    let account = sessionStorage.getItem("selectBan");
    let subscriber = this.global.getSuscriberByDefault(atob(account));
    this.global.suspendedAccount("S", atob(account), btoa(subscriber), getAccount.AccounInfo.billBalanceField);
  }
  addRecharge() {
    if (this.global.validateSession() === true) {

      if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.banStatusField === 'S' || JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.banStatusField === 's') {
        // alertify.set({labels: {ok: 'Pagar',cancel: 'Cancelar'}});
        // alertify.confirm("<div class='dialogTitle'>Aviso</div><div class='dialogContent'>Su cuenta " + this.selectBan +
        // " esta suspendida. Para activar la misma, favor realice su pago.</div>", function (e) {
        //     if(e){
        //         util. doPaymentSusp();
        //     }
        // });
        this.notif2();
      }
      else {
        for (var i = 0; i < JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo.length; i++) {

          if (JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[i].subscriberNumberField == this.subscriberReciever) {
            this.global.notif("Este suscriptor no es valido para el regalo.");
            return false;
          }
        }
        this.global.validateSession();


        if (this.validaciones()) {
          if (this.acceptTerms) {
            if (this.status == "S") {
              this.notif2();
            }
            else {
              if (this.check1.checked == true || this.check2.checked == true || this.check3.checked == true || this.check4.checked == true) {
                this.loadingScreenService.startLoading();
                this.services.GetSubscriber(this.token, this.subscriberReciever).subscribe(data => {
                  if (data.HasError == false) {
                    var typeAccount = this.global.checkTypeAccount(data.AccountType, data.AccountSubType);
                    if (typeAccount === 'prepago') {
                      this.banRecieve = data.Account;
                      this.subscriberRecieverName = data.AccountName;
                      var balanceAccount = 0; //revisar el balance
                      this.validateCreditLimit(this.banRecieve, balanceAccount, this.amount);
                    }
                    else {
                      this.loadingScreenService.stopLoading();
                      if (data.ErrorDesc != '' && data.ErrorDesc != null) {
                        this.global.notif(data.ErrorDesc);
                      }
                      else {
                        this.global.notif("Suscriptor no encontrado.");
                      }
                    }
                  }
                  else {
                    this.loadingScreenService.stopLoading();
                    this.global.notif(data.ErrorDesc);
                  }
                });
              }
              else {
                this.global.notif("Debe selecionar una de las opciones de recarga.");
              }
            }
          } else {
            this.global.notif("Debe aceptar los Términos y Condicciones.");
          }
        } else {
          if (this.showErrorCelNum) {
            this.global.notif("El número de teléfono es un campo requerido.");
            return false;
          }
          if (this.showErrorCelNumInvalido) {
            this.global.notif("Por favor introduzca un número de teléfono valido.");
            return false;
          }
        }

      }
    }
  }
  validaciones() {
    var sw = true;
    if (this.subscriberReciever == "") {
      this.showErrorCelNum = true;
      sw = false;
    }
    else {
      this.showErrorCelNum = false;
      if (this.subscriberReciever.length > 0 && this.subscriberReciever.length < 10) {
        this.showErrorCelNumInvalido = true;
        sw = false;
      }
      else {
        this.showErrorCelNumInvalido = false;
      }
    }
    return sw;
  }
}

